import {
  loginBegin,
  loginFailure,
  loginSuccess,
  logoutBegin,
  logoutFailure,
  logoutSuccess,
  sendResetLinkBegin,
  sendResetLinkFailure,
  sendResetLinkSuccess,
  resetPasswordBegin,
  resetPasswordFailure,
  resetPasswordSuccess,
  signupBegin,
  signupFailure,
  signupSuccess,
  fetchGradesBegin,
  fetchGradesFailure,
  fetchGradesSuccess,
  fetchRolesBegin,
  fetchRolesFailure,
  fetchRolesSuccess,
  fetchSchoolsBegin,
  fetchSchoolsFailure,
  fetchSchoolsSuccess,
  fetchSchoolsByPasscodeBegin,
  fetchSchoolsByPasscodeFailure,
  fetchSchoolsByPasscodeSuccess,
  createGroupBegin,
  createGroupFailure,
  createGroupSuccess,
  fetchProfileBegin,
  fetchProfileFailure,
  fetchProfileSuccess,
  updateProfileBegin,
  updateProfileFailure,
  updateProfileSuccess,
} from "../actions/authActions";

import StorageManager from "../../storage/StorageManager";
import API, { ENDPOINTS } from "../../api/apiService";

import { ACCESS_TOKEN, REFRESH_TOKEN } from "../../storage/StorageKeys";

export function performLogin(email, password) {
  return async (dispatch) => {
    dispatch(loginBegin());
    try {
      const resp = await API.post(
        ENDPOINTS.LOGIN,
        { email, password, grantType: "password" },
        false
      );
      if (resp.status === 200) {
        const { data } = resp;
        StorageManager.put(ACCESS_TOKEN, data.accessToken);
        StorageManager.put(REFRESH_TOKEN, data.refreshToken);
        dispatch(loginSuccess(data));
      }
      return resp;
    } catch (resp) {
      dispatch(loginFailure(resp));
      return resp;
    }
  };
}

export function performLogout(userId, token) {
  return async (dispatch) => {
    dispatch(logoutBegin());
    try {
      const payload = {
        deviceId: "",
        deviceType: "web",
        schoolId: "",
        token: token,
        userId: userId,
      };
      const deleteToken = await API.post(ENDPOINTS.DELETE_TOKEN, payload);
      const resp = await API.post(ENDPOINTS.LOGOUT(userId));
      if (resp.status === 200) {
        dispatch(logoutSuccess());
        StorageManager.remove(ACCESS_TOKEN);
        StorageManager.remove(REFRESH_TOKEN);
        document.location.replace("/auth/login");
      }
      return resp;
    } catch (resp) {
      dispatch(logoutFailure(resp));
      return resp;
    }
  };
}

export function signup(payload) {
  return async (dispatch) => {
    dispatch(signupBegin(payload));
    try {
      const resp = await API.post(ENDPOINTS.SIGNUP, payload, false);
      if (resp.status === 200) {
        const {
          data: { authResponse },
        } = resp;
        StorageManager.put(ACCESS_TOKEN, authResponse.accessToken);
        StorageManager.put(REFRESH_TOKEN, authResponse.refreshToken);
        dispatch(signupSuccess(resp.data.authResponse));
      }
      return resp;
    } catch (resp) {
      dispatch(signupFailure(resp));
      return resp;
    }
  };
}

export function sendResetLink(email) {
  return async (dispatch) => {
    dispatch(sendResetLinkBegin());
    try {
      const resp = await API.post(
        ENDPOINTS.SEND_RESET_PASSWORD_MAIL,
        { email },
        false
      );
      if (resp.status === 200) {
        dispatch(sendResetLinkSuccess());
      }
      return resp;
    } catch (resp) {
      dispatch(sendResetLinkFailure(resp));
      return resp;
    }
  };
}

export function resetPassword(data) {
  return async (dispatch) => {
    dispatch(resetPasswordBegin());
    try {
      const resp = await API.post(ENDPOINTS.RESET_PASSWORD, data, false);
      if (resp.status === 200) {
        dispatch(resetPasswordSuccess());
      }
      return resp;
    } catch (resp) {
      dispatch(resetPasswordFailure(resp));
      return resp;
    }
  };
}

export function fetchGrades() {
  return async (dispatch) => {
    dispatch(fetchGradesBegin());
    try {
      const resp = await API.get(ENDPOINTS.FETCH_GRADES);
      if (resp.status === 200) {
        dispatch(fetchGradesSuccess(resp.data));
      }
      return resp;
    } catch (resp) {
      const { data } = resp;
      dispatch(fetchGradesFailure(data));
      return data;
    }
  };
}

export function fetchSchools() {
  return async (dispatch) => {
    dispatch(fetchSchoolsBegin());
    try {
      const resp = await API.get(ENDPOINTS.FETCH_SCHOOLS);
      if (resp.status === 200) {
        dispatch(fetchSchoolsSuccess(resp.data.schools));
      }
      return resp;
    } catch (resp) {
      const { data } = resp;
      dispatch(fetchSchoolsFailure(data));
      return data;
    }
  };
}

export function fetchSchoolsByPasscode(passcode) {
  return async (dispatch) => {
    dispatch(fetchSchoolsByPasscodeBegin());
    try {
      const resp = await API.get(ENDPOINTS.FETCH_SCHOOLS_BY_PASSCODE(passcode));
      if (resp.status === 200) {
        dispatch(fetchSchoolsByPasscodeSuccess(resp.data));
      }
      return resp;
    } catch (resp) {
      const { data } = resp;
      dispatch(fetchSchoolsByPasscodeFailure(data));
      return data;
    }
  };
}

export function fetchRoles() {
  return async (dispatch) => {
    dispatch(fetchRolesBegin());
    try {
      const resp = await API.get(ENDPOINTS.FETCH_ROLES);
      if (resp.status === 200) {
        dispatch(fetchRolesSuccess(resp.data));
      }
      return resp;
    } catch (resp) {
      const { data } = resp;
      dispatch(fetchRolesFailure(data));
      return data;
    }
  };
}

export function createGroup(payload) {
  return async (dispatch) => {
    dispatch(createGroupBegin());
    try {
      const resp = await API.post(ENDPOINTS.CREATE_GROUP, payload);
      if (resp.status === 200) {
        dispatch(createGroupSuccess());
      }
      return resp;
    } catch (resp) {
      const { data } = resp;
      dispatch(createGroupFailure(data));
      return data;
    }
  };
}

export function fetchProfile() {
  return async (dispatch) => {
    dispatch(fetchProfileBegin());
    try {
      const resp = await API.get(ENDPOINTS.FETCH_PROFILE);
      if (resp.status === 200) {
        dispatch(fetchProfileSuccess({ data: resp.data }));
      }
      return resp;
    } catch (resp) {
      const { data } = resp;
      dispatch(fetchProfileFailure(data));
      return data;
    }
  };
}

export function updateProfile(payload) {
  return async (dispatch) => {
    dispatch(updateProfileBegin());
    try {
      const resp = await API.put(ENDPOINTS.UPDATE_PROFILE, payload);
      if (resp.status === 200) {
        dispatch(updateProfileSuccess());
      }
      return resp;
    } catch (resp) {
      const { data } = resp;
      dispatch(updateProfileFailure(data));
      return data;
    }
  };
}
